module.exports = __webpack_public_path__ + "img/aa4.9604219a.png";